require("./bootstrap");
window.Vue = require("vue");

import InstantSearch from "vue-instantsearch";
import {
  Results as AisResults,
  Component
} from "vue-instantsearch";
import VueRouter from "vue-router";
import {
  routes,
  beforEach
} from "./routes";
import store from "./store";
import {
  SvgIcon
} from "./utils";
import VueFuse from "vue-fuse";
import App from "./containers";
import VueTheMask from "vue-the-mask";
import {
  VueReCaptcha
} from "vue-recaptcha-v3";
import Element from "element-ui";
// import "element-ui/lib/theme-chalk/index.css";
import "../sass/element-variables.scss";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
import {
  library
} from "@fortawesome/fontawesome-svg-core"
import {
  faTractor,
  faCar,
  faCaretUp
} from "@fortawesome/free-solid-svg-icons";
import {
  faTrashAlt,
  faSave,
  faFileAlt,
  faCloudDownload,
  faPen,
  faTimes,
  faPlus,
  faFileDownload,
  faInfoCircle,
  faBars,
  faTrash
} from "@fortawesome/pro-light-svg-icons";
import {
  FontAwesomeIcon
} from "@fortawesome/vue-fontawesome";
import VueDataTables from "vue-data-tables";
import interceptors from "./utils/interceptors";

library.add([
  faTractor,
  faCar,
  faCaretUp,
  faTrashAlt,
  faSave,
  faFileAlt,
  faPen,
  faTimes,
  faCloudDownload,
  faPlus,
  faFileDownload,
  faInfoCircle,
  faBars,
  faTrash
])

export default {
  components: {
    AisResults
  },
  mixins: [Component]
};

Vue.component("font-awesome-icon", FontAwesomeIcon)
Vue.config.productionTip = false

Vue.component("svg-icon", SvgIcon);
Vue.use(InstantSearch);
Vue.use(VueFuse);
Vue.use(VueTheMask);
Vue.use(VueReCaptcha, {
  siteKey: process.env.MIX_RECAPTCHA_SITE_KEY,
  loaderOptions: {
    useRecaptchaNet: true
  }
});
Vue.use(Element);
Vue.use(VueDataTables);
locale.use(lang);

Vue.use(VueRouter);
const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  }
});

router.beforeEach(beforEach);

interceptors();

new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App
  }
});
